import { observer } from "mobx-react";
import { useTranslation } from "@/i18n";
import { NotificationsForm } from "@/components/profile-settings/notifications/notifications-form";
import { TeamsLinkBlock } from "@/components/profile-settings/notifications/teams-link-block";
import { SettingsPageShell } from "@/components/shared/settings-page-shell";

export const ProfileNotificationsPage = observer(function ProfileNotificationsPage() {
  const { t } = useTranslation();

  return (
    <SettingsPageShell
      title={t("profile_settings.notifications.title")}
      description={t("profile_settings.notifications.description")}
    >
      {/* Above the switches, because it answers a question that comes first: the
          switches decide WHICH notifications you get, and this decides WHERE. It
          renders nothing at all unless the Teams flag is on and one of your
          workspaces has actually enabled the channel, so for almost everybody this
          page is exactly what it was. */}
      <TeamsLinkBlock />
      <NotificationsForm />
    </SettingsPageShell>
  );
});
